import * as Sentry from "@sentry/browser"
import { useTokenData } from "../../../hooks/useTokenData"

export const logErrorPartial = (user?: string | null) => {
  if (user) {
    return (message: string) => {
      Sentry.withScope(scope => {
        scope.setUser({
          username: user,
          email: user
        })
        Sentry.captureException(new Error(`${user} - ${message}`))
      })
    }
  } else {
    return (message: string) => {
      Sentry.captureException(new Error(`Unknown user: - ${message}`))
    }
  }
}

export const logErrorPartialPublic = (message: string) => {
  Sentry.captureException(new Error(`Public page: - ${message}`))
}

function useSentry() {
  const { data } = useTokenData()

  try {
    const logError = logErrorPartial(data?.email)
    return { captureMessage: logError }
  } catch (error) {
    return { captureMessage: logErrorPartial(null) }
  }
}

const showReportDialog = () => {
  return Sentry.showReportDialog({
    lang: "it",
    title: "Scrivici cosa è successo!",
    subtitle: "Il nostro team è già stato informato.",
    subtitle2: "Per velocizzare la risoluzione, compila il form.",
    labelSubmit: "Invia",
    successMessage: "Grazie! Ti contatteremo appena il problema sarà risolto!",
    errorFormEntry: "Qualche campo non è valido. Per favore, correggi gli errori e prova ancora."
  })
}

export { useSentry, showReportDialog }
